import { useState } from "react";
import { LegalDialog } from "./LegalDialogs";

const Footer = () => {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  return (
    <>
      <footer className="bg-white border-t">
        <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 gap-8">
            <div>
              <h3 className="text-sm font-semibold text-gray-900 tracking-wider uppercase">Product</h3>
              <ul className="mt-4 space-y-4">
                <li>
                  <a href="#features" className="text-gray-600 hover:text-cso-600">
                    Features
                  </a>
                </li>
                <li>
                  <a href="#pricing" className="text-gray-600 hover:text-cso-600">
                    Pricing
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="text-sm font-semibold text-gray-900 tracking-wider uppercase">Legal</h3>
              <ul className="mt-4 space-y-4">
                <li>
                  <button 
                    onClick={() => setShowPrivacy(true)} 
                    className="text-gray-600 hover:text-cso-600"
                  >
                    Privacy
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => setShowTerms(true)} 
                    className="text-gray-600 hover:text-cso-600"
                  >
                    Terms
                  </button>
                </li>
              </ul>
            </div>
          </div>
          <div className="mt-12 border-t pt-8">
            <p className="text-center text-gray-500">
              2025 © CMPGFB LLC.
            </p>
          </div>
        </div>
      </footer>

      <LegalDialog 
        isOpen={showPrivacy} 
        onClose={() => setShowPrivacy(false)} 
        type="privacy" 
      />
      
      <LegalDialog 
        isOpen={showTerms} 
        onClose={() => setShowTerms(false)} 
        type="terms" 
      />
    </>
  );
};

export default Footer;